import {createAction, props} from '@ngrx/store';
import {HttpResponse} from '@angular/common/http';

export enum ExportActionTypes {
    exportAccounts = '[Export] Accounts',
    exportAccountsSuccess = '[Export] Accounts success',
    exportAccountsFailure = '[Export] Accounts failure',
}

export const ExportAccounts = createAction(
    ExportActionTypes.exportAccounts,
    props<{ fields: string[] }>()
)

export const ExportAccountsSuccess = createAction(
    ExportActionTypes.exportAccountsSuccess,
    props<{ res: HttpResponse<Blob> }>()
)

export const ExportAccountsFailure = createAction(
    ExportActionTypes.exportAccountsFailure,
    props<Error>()
)
